import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CloverOrderService} from '../../../_services/cloverOrder.service';
import {User} from '../../../_models';
import {AESEncryptDecryptService} from '../../../_services/aesencrypt-decrypt.service';
import {AlertService, UserService} from '../../../_services';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';


@Component({
    selector: 'app-notification-popup',
    templateUrl: './custom-input-popup.html',
    styleUrls: ['./custom-input-popup.component.scss']
})
export class CustomInputPopupComponent implements OnInit {

    description: string;
    labelName = "New Tab Name";
    message: string;
    currentUser: User;
    currentTableName: string;
    errorMessage: string;
    selectedRole: string;
    loading = false;
    assignedTables = false;
    inputValue = '';
    button_text = 'Submit';


    constructor(private dialogRef: MatDialogRef<CustomInputPopupComponent>, private cloverOrderService: CloverOrderService,
                private alertService: AlertService, private userService: UserService, private router: Router, private notifier: NotifierService,
                private _AESEncryptDecryptService: AESEncryptDecryptService, @Inject(MAT_DIALOG_DATA) data) {
        this.description = data.title;
        this.message = data.message;
        this.labelName = data.labelName || data.label || this.labelName;
        this.button_text = data.button_text;
        this.currentTableName = data.currentTableName;
    }

    ngOnInit() {
    }


    close() {
        this.dialogRef.close();
    }

    public showNotification(type: string, message: string): void {
        this.notifier.notify(type, message);
    }

    submit() {
        if (!this.inputValue || this.inputValue.trim().length < 1) {
            this.showNotification('warning', 'Please enter a value');
            return;
        }
        this.dialogRef.close({
            customerName: this.inputValue.trim(),
        });
    }
}
